import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'

export default (component) => Vue.component('FooterContainer', {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      activeTabView: (state) => state.activeTabView,
    }),
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapGetters('slideProgress', [
      'isLastVisibleSlide',
    ]),
    isCtaShowing() {
      if (
        !this.presentation
        || !this.slide
        || !this.presentation.id
        || !this.slide.id
      ) return false
      if (this.presentation.user && this.presentation.user.isGuest) return false
      if (!this.isLastVisibleSlide) return false
      if (this.slide.type === 'pickAnswer') return false
      if (this.activeTabView !== 'slide') return false

      return true
    },
    canDisplayFooter() {
      return this.presentation && this.presentation.id && this.presentation.planType !== 'white-label'
    },
  },
  render(createElement) {
    // do not show any footer for white label users
    if (!this.canDisplayFooter) return null

    return createElement(component, {
      props: {
        isCtaShowing: this.isCtaShowing,
      },
    })
  },
})
